// Pick a string from a possibly-localized value.
// Mongo stores some fields (Unit.name, Property.description) as {hr, en, de, it, ...}.
// Components should never render the raw object — use pickLocale to get a safe string.
export function pickLocale(value, lang = "hr", fallback = "") {
  if (value == null) return fallback;
  if (typeof value === "string" || typeof value === "number") return String(value);
  if (typeof value === "object") {
    if (value[lang]) return value[lang];
    if (value.hr) return value.hr;
    if (value.en) return value.en;
    const vals = Object.values(value).filter((v) => typeof v === "string" && v.trim());
    return vals[0] || fallback;
  }
  return fallback;
}
